import background from "../../assets/img/login-background.png";
import styles from "./DefaultPage.module.scss";

const DefaultPage = () => {
  return (
    <div
      className={styles.login}
      style={{ backgroundImage: `url(${background})` }}
    >
      <h1 className={styles.welcome}>
        <p className={styles.title}>Добро пожаловать в Ситуационную панель!</p>
        <p className={styles.subTitle}>
          Для продолжения работы выберите нужный раздел в меню слева.
        </p>
      </h1>
    </div>
  );
};

export default DefaultPage;
